import React, { useState } from "react";
import MyJobs from "../components/Carrer/MyJobs";

import Aside from "../modules/SideNav/Aside";

function MyJobsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <MyJobs handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default MyJobsLayout;
